import {from, fromEvent, Observable} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {DestroyRef} from "@angular/core";
import {mergeMap} from "rxjs/operators";
import {HasEventTargetAddRemove} from "rxjs/internal/observable/fromEvent";

/** Kaller angitt vedData når angitt observerbar leverer data, avslutter observerbar når angitt destroyRef trigges.*/
export function konsumerTilDestroy<T>(observerbar: Observable<T>, destroyRef: DestroyRef, vedData: (mottatt: T) => void) {
    observerbar.pipe(takeUntilDestroyed(destroyRef))
      .subscribe(data => vedData(data));
}

/** Lytter til angitte UI-hendelser på angitt kilde og returnerer observerbar som leverer disse UIEventene */
export function fraUiHendelser<T extends UIEvent>(kilde: HasEventTargetAddRemove<T> | ArrayLike<HasEventTargetAddRemove<T>>, ...hendelsesnavn:string[]):Observable<T>{
    return from(hendelsesnavn).pipe(mergeMap(hendelsesnavn => fromEvent<T>(kilde, hendelsesnavn)))
}
